/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface SettingEntity
 */
export interface SettingEntity {
    /**
     * 設定ID
     * @type {string}
     * @memberof SettingEntity
     */
    id: string;
    /**
     * 設定名
     * @type {string}
     * @memberof SettingEntity
     */
    label: string;
    /**
     * 設定値
     * @type {string}
     * @memberof SettingEntity
     */
    value: string;
    /**
     * テナントID
     * @type {string}
     * @memberof SettingEntity
     */
    tenantId: string;
    /**
     * 作成日時
     * @type {Date}
     * @memberof SettingEntity
     */
    createdAt: Date;
    /**
     * 最終更新日時
     * @type {Date}
     * @memberof SettingEntity
     */
    updatedAt: Date;
    /**
     * 作成ユーザー
     * @type {UserEntity}
     * @memberof SettingEntity
     */
    createdBy: UserEntity;
    /**
     * 最終更新ユーザー
     * @type {UserEntity}
     * @memberof SettingEntity
     */
    updatedBy: UserEntity;
}

/**
 * Check if a given object implements the SettingEntity interface.
 */
export function instanceOfSettingEntity(value: object): value is SettingEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    return true;
}

export function SettingEntityFromJSON(json: any): SettingEntity {
    return SettingEntityFromJSONTyped(json, false);
}

export function SettingEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SettingEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'value': json['value'],
        'tenantId': json['tenantId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'createdBy': UserEntityFromJSON(json['createdBy']),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
    };
}

export function SettingEntityToJSON(json: any): SettingEntity {
    return SettingEntityToJSONTyped(json, false);
}

export function SettingEntityToJSONTyped(value?: SettingEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'value': value['value'],
        'tenantId': value['tenantId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdBy': UserEntityToJSON(value['createdBy']),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
    };
}

